// apps/web/src/data/vocab/library.ts

import vocabRaw from "./vocab.json";
import type { TopicKey, VocabEntry, VocabLibrary } from "./types";

// vocab.json is shipped as static curated data — Zod-validated at curation
// time, so a runtime parse on every import would be redundant overhead.
// Cast through `unknown` to land it in the typed shape.
const LIBRARY: VocabLibrary = vocabRaw as unknown as VocabLibrary;

export function getVocabLibrary(): VocabLibrary {
  return LIBRARY;
}

export function getEntriesByTopic(topic: TopicKey): VocabEntry[] {
  return LIBRARY.entries.filter((e) => e.topic === topic);
}

/** True when the entry has anything worth expanding for. Plain wordlist
 *  rows render without a chevron and are not tappable. */
export function isEnriched(entry: VocabEntry): boolean {
  return (
    entry.examples.length > 0 ||
    (entry.prepositions?.length ?? 0) > 0 ||
    Boolean(entry.usageTip) ||
    Boolean(entry.pastTense) ||
    Boolean(entry.comparative) ||
    Boolean(entry.plural)
  );
}
